import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import { WithChildren } from "@/ui/types";

export interface ScrollTopProps extends WithChildren {}

export const ScrollToTop = ({ children }: ScrollTopProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <>{children}</>;
};
